/* Launcherul de chat „Monica este online” (bula + capul de maimuță peste Shopify Inbox).
   Mutat aici din assets/am-collection-premium.js pe 19.10.2026, fără nicio schimbare de cod, ca să-l poată
   încărca și layout/black-friday.liquid fără restul celor 54 KB. Se încarcă din layout/theme.liquid,
   layout/theme.shogun.landing.liquid și layout/black-friday.liquid. Citește window.filepaths.am_monkey_head
   și window.translations.am_chat_* (snippets/global-variables.liquid; pe landing-ul BF, shimul inline din
   layout). CSS-ul: assets/am-chat-launcher.css.
   Pe layout/theme.shogun.landing.liquid launcherul NU se construiește: layoutul nu pune globalele, deci img e null și
   build() nu rulează (preexistent, la fel înainte de mutare; prins de Codex 19.10). Pe Shogun rămâne activă doar garda
   CSS care ascunde pastila nativă Inbox 31 s. */
/* ------------------------------------------------------------------
   Custom chat launcher (ported from TUDOR-TEST am-draft-fixes.js,
   2026-07-30): replaces Shopify Inbox's default "Aveți nevoie de ajutor?"
   pill with the Audio Monkey monkey head (bottom-right) plus a dismissible
   speech bubble carrying the same text. Pressing the monkey opens the
   chat; the X hides the whole launcher (monkey + bubble) for the session.

   How it hooks in: Shopify Inbox renders as <shopify-chat> with an OPEN
   shadow root, so this (a) injects a style into that shadow root hiding
   only its `.activator` pill — the chat window itself is untouched — and
   (b) forwards clicks from the monkey to the hidden native activator,
   which keeps ALL of Inbox's own open/close/unread logic intact. This is
   a skin, not a reimplementation — no parallel chat state.

   Everything is built only AFTER the native activator exists, so if the
   Inbox app is removed or fails to load, no dead monkey button renders.
   A MutationObserver re-asserts the hiding style if Inbox re-renders its
   shadow DOM (it does, on first open — see amEnsureActivatorHidden below).

   SITE-WIDE, not product-pages-only (TUDOR-TEST originally restricted the
   monkey to product pages; Tudor asked for it everywhere here). */
(function () {
  'use strict';

  /* Inbox re-parents its UI after first open: initially `button.activator`
     sits directly in <shopify-chat>'s shadow root, but opening the window
     mounts a nested <shopify-agent-runtime> (its own open shadow root) and
     re-renders everything inside that. A style or querySelector aimed at
     the outer root therefore works exactly once; after open+close the
     native pill reappears. Both helpers below walk nested open shadow
     roots so they keep working across the remount. */
  function amChatRoots() {
    var chat = document.querySelector('shopify-chat');
    var roots = [];
    (function walk(root) {
      if (!root) return;
      roots.push(root);
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) walk(el.shadowRoot);
      });
    })(chat && chat.shadowRoot);
    return roots;
  }
  function amFindActivator() {
    var roots = amChatRoots();
    for (var i = 0; i < roots.length; i++) {
      var a = roots[i].querySelector('button.activator');
      if (a) return a;
    }
    return null;
  }
  /* 2026-07-30 — REWRITTEN. The previous version pinned the renderer and got
     the tab killed ("This webpage was reloaded because a problem occurred",
     reported by Tudor, reproduced live: even a trivial eval timed out).

     The runaway loop it had, for the record, so it does not come back:
     it installed ONE OBSERVER PER shadow root, each with {childList,subtree},
     and each observer's callback re-ran this whole function — which calls
     appendChild(style) INTO an observed root. That mutation retriggers the
     observer that just fired. The appendChild was nominally guarded by an
     `#am-hide-activator` lookup, but Inbox WIPES AND REBUILDS the runtime
     root on close (see comment below), which clears the guard and re-opens
     the cycle. With N observers each re-walking every root via
     querySelectorAll('*') over the whole nested-shadow forest, one mutation
     fanned out into an O(N²) cascade of full tree walks.

     Four changes, all four needed — any one alone still leaves a way in:
       1. re-entrancy flag, so a mutation raised BY this function cannot
          re-enter it;
       2. ONE observer total, not one per root;
       3. disconnect() before mutating, observe() after, so our own writes
          are never seen by the observer at all;
       4. debounce, so a burst of Inbox's own mutations coalesces into a
          single pass. */
  var amHideObserver = null;
  var amHidingNow = false;
  var amHideQueued = false;

  function amApplyHiding() {
    amChatRoots().forEach(function (root) {
      if (!(root.getElementById && root.getElementById('am-hide-activator'))) {
        var hide = document.createElement('style');
        hide.id = 'am-hide-activator';
        /* NOT display:none. Inbox sets `display` on the pill with
           !important from adoptedStyleSheets, which beats both a shadow
           <style> and an inline !important. The properties below are ones
           Inbox does not contest, and a hidden element still receives
           .click(), which the monkey relies on. */
        hide.textContent = 'button.activator { visibility: hidden !important;' +
          ' opacity: 0 !important; pointer-events: none !important;' +
          ' clip-path: inset(100%) !important; }';
        root.appendChild(hide);
      }
      // Belt and braces: same set inline, re-applied whenever Inbox
      // re-creates the pill.
      root.querySelectorAll && root.querySelectorAll('button.activator').forEach(function (a) {
        a.style.setProperty('visibility', 'hidden', 'important');
        a.style.setProperty('opacity', '0', 'important');
        a.style.setProperty('pointer-events', 'none', 'important');
        a.style.setProperty('clip-path', 'inset(100%)', 'important');
      });
    });
  }

  function amEnsureActivatorHidden() {
    if (amHidingNow) return;              // (1) our own writes must not re-enter
    amHidingNow = true;
    try {
      if (amHideObserver) amHideObserver.disconnect();   // (3) go deaf while writing
      amApplyHiding();

      /* (2) A SINGLE observer, re-pointed at the outermost chat root after
         every pass. subtree:true is still load-bearing — the agent runtime
         mounts as a grandchild, and Inbox's close wipes and rebuilds that
         root's contents, including our injected style — but one observer on
         the outer root sees those subtree mutations without needing a
         per-root observer fleet. */
      var chat = document.querySelector('shopify-chat');
      var outer = chat && chat.shadowRoot;
      if (outer && typeof MutationObserver !== 'undefined') {
        if (!amHideObserver) {
          amHideObserver = new MutationObserver(function () {
            if (amHideQueued) return;     // (4) coalesce a burst into one pass
            amHideQueued = true;
            setTimeout(function () {
              amHideQueued = false;
              amEnsureActivatorHidden();
            }, 50);
          });
        }
        amHideObserver.observe(outer, { childList: true, subtree: true });
      }
    } finally {
      amHidingNow = false;
    }
  }

  /* Program showroom (footer-group.json, footer-block-customer-support-1):
     Luni-Vineri 9:30-19:00, Sâmbătă 10:00-15:00. Checked in the visitor's
     local time zone (Europe/Bucharest is where the business runs, but a
     browser clock is close enough for a UI nicety like this and needs no
     TZ library). */
  function amIsOpenNow() {
    var d = new Date();
    var day = d.getDay(); // 0 Sun .. 6 Sat
    var mins = d.getHours() * 60 + d.getMinutes();
    if (day >= 1 && day <= 5) return mins >= 9 * 60 + 30 && mins < 19 * 60;
    if (day === 6) return mins >= 10 * 60 && mins < 15 * 60;
    return false; // Sunday
  }

  /* Don't greet the visitor the instant the page loads — wait until they
     show intent: browsing a product/collection page, or, on any other
     page (home, cart, etc.), the first scroll or click. */
  function amWhenBrowsing(cb) {
    var bodyClass = document.body.className;
    if (/\btemplate-(product|collection|search)\b/.test(bodyClass)) {
      cb();
      return;
    }
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      window.removeEventListener('scroll', fire);
      window.removeEventListener('click', fire);
      cb();
    }
    window.addEventListener('scroll', fire, { passive: true, once: true });
    window.addEventListener('click', fire, { once: true });
  }

  function initChatLauncher() {
    if (document.getElementById('am-chat-launcher')) return;
    var img = (window.filepaths && window.filepaths.am_monkey_head) || null;

    var dismissed = false;
    try { dismissed = sessionStorage.getItem('am_chat_hidden') === '1'; } catch (e) {}

    /* 2026-07-30: interval 300ms → 1000ms, 100 tries → 30 (same ~30s budget).
       amFindActivator() walks the entire nested-shadow forest with
       querySelectorAll('*') on every tick; at 300ms that was ~100 full tree
       walks per page load, stacked on top of the observer cascade that was
       crashing the renderer. Inbox takes seconds to boot anyway, so a 1s
       cadence costs nothing perceptible. */
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (!amFindActivator()) {
        if (tries > 30) clearInterval(poll); // ~30s: Inbox absent, give up quietly
        return;
      }
      clearInterval(poll);
      amEnsureActivatorHidden();
      if (img && !dismissed) amWhenBrowsing(build);
    }, 1000);

    function build() {
      var open = amIsOpenNow();
      /* 2026-08-27: textele erau HARDCODATE in romana, deci .bg le afisa in romana
         indiferent de traduceri (acelasi tipar ca placeholder-ul de cautare din
         header.liquid). Se citesc acum din window.translations, populat din Liquid
         cu filtrul `| t` in snippets/global-variables.liquid. Fallback-ul romanesc
         ramane, ca sa nu se strice nimic daca o cheie lipseste. */
      var T = window.translations || {};
      var title = open
        ? (T.am_chat_online || 'Monica este online')
        : (T.am_chat_offline || 'Monica revine în program');
      var dotClass = open ? 'am-chat-live-dot' : 'am-chat-live-dot am-chat-live-dot--offline';

      var wrap = document.createElement('div');
      wrap.id = 'am-chat-launcher';
      wrap.innerHTML =
        '<div class="am-chat-bubble" role="status">' +
          '<strong class="am-chat-bubble__title"><span class="' + dotClass + '" aria-hidden="true"></span>' + title + '</strong>' +
          '<span class="am-chat-bubble__sub">' + (T.am_chat_sub || 'Cere sfaturi sau oferte promo.') + '</span>' +
        '</div>' +
        '<div class="am-chat-monkey-wrap">' +
          '<button type="button" class="am-chat-close" aria-label="' + (T.am_chat_hide || 'Ascunde chatul') + '">&times;</button>' +
          '<button type="button" class="am-chat-monkey" aria-label="' + (T.am_chat_open || 'Deschide chatul') + '" aria-haspopup="dialog">' +
            '<img src="' + img + '" alt="" width="64" height="64" loading="lazy">' +
          '</button>' +
        '</div>';
      document.body.appendChild(wrap);

      var bubble = wrap.querySelector('.am-chat-bubble');

      function openChat(e) {
        /* Both lines are load-bearing: after the first open, Inbox's
           runtime installs an outside-click-closes listener on the
           document. Forwarding synchronously means the chat opens and
           then our own still-bubbling click reaches that listener as an
           "outside" click and closes it again in the same tick — reopen
           appears dead. Stop the bubble, and hand the activator click to
           the next tick so the triggering event is fully finished. */
        if (e) { e.preventDefault(); e.stopPropagation(); }
        setTimeout(function () {
          var a = amFindActivator();   // resolved fresh: survives the runtime remount
          if (a) a.click();            // Inbox's own toggle keeps all its logic
          amEnsureActivatorHidden();   // the remount brings a new root; re-hide there
        }, 0);
        bubble.hidden = true;
      }
      wrap.querySelector('.am-chat-monkey').addEventListener('click', openChat);
      bubble.addEventListener('click', openChat);
      // X on the monkey's corner hides the WHOLE launcher for the session.
      wrap.querySelector('.am-chat-close').addEventListener('click', function (e) {
        e.stopPropagation();
        wrap.remove();
        try { sessionStorage.setItem('am_chat_hidden', '1'); } catch (e2) {}
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatLauncher);
  } else {
    initChatLauncher();
  }
})();
